import { trimSlashes } from '@/util/helpers/string'
import { isNullOrUndefined } from '~/util/validators/baseComponentsValidators'
import { CASHBOX_QUERY } from '~/components/Cashbox/enum'

export const modalService = {
  modalExceptions: [CASHBOX_QUERY.CASHBOX, CASHBOX_QUERY.CASHBOX_ERROR, CASHBOX_QUERY.CASHBOX_SUCCESS, CASHBOX_QUERY.CASHBOX_EXT],
  
  /** @param {unknown} query
    * @returns {boolean} */
  isValidQuery(query) {
    return !isNullOrUndefined(query)
  },
  /** @param {string} name
    * @returns {string} */
  formatName(name = '') {
    if (!name) return
    return trimSlashes(name).replace(/^(ru\/|ua\/)/, '').replaceAll('-', '/')
  },
  /** @template T
    * @param {() => Promise<T>} fn - The asynchronous function to execute, which returns a promise.
    * @returns {Promise<{ data: T, isSuccess: true } | { isSuccess: false, error: any }>} */
  async safePromise(fn) {
    try {
      const resp = await fn()
      return {
        data: resp,
        isSuccess: true,
      }
    }
    catch (e) {
      return {
        isSuccess: false,
        error: e,
      }
    }
  },

  async middlewareRunner({ middleware, context }) {
    if (typeof middleware === 'string') {
      middleware = [middleware]
    }

    for (const name of middleware) {
      let mw = null

      try {
        // Dynamically require the middleware from the middleware folder
        mw = require(`@/middleware/${name}`).default
      }
      catch (e) {
        console.error(`Middleware "${name}" not found.`)
        throw e
      }

      // Simulate a middleware context with properties accessible in the middleware
      const middlewareContext = {
        ...context,
        route: context.$route,
        store: context.$store,
        redirect: (path) => context.$router.push(path),
      }

      // Execute the middleware if it is a function
      if (typeof mw === 'function') {
        await mw(middlewareContext)
      }
    }
  },

  isSmallModal(name = '') {
    return modalService.modalExceptions.includes(name)
  },
}
